"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _errorMessages = require("../errorMessages");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var IdentityUtils = /*#__PURE__*/function () {
  function IdentityUtils() {
    _classCallCheck(this, IdentityUtils);
  }

  _createClass(IdentityUtils, null, [{
    key: "getErrorDetails",
    value: function getErrorDetails(errors) {
      if (errors && errors.length !== 0) {
        var message = {
          title: errors[0].title,
          type: 'is-error',
          body: /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, errors[0].detail))
        };
        return message;
      } else {
        return _errorMessages.FATAL_ERROR;
      }
    }
  }]);

  return IdentityUtils;
}();

exports.default = IdentityUtils;
//# sourceMappingURL=IdentityUtils.js.map